import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

const VendorUser = () => {
  const context = useOutletContext();
  return (
    <Outlet context={context}/>
  )
}

export default VendorUser